import { Button } from "../../Button";
import { ConfirmationModal } from "../../ConfirmationModal";
import { editMeeting, getPeople, getUnits } from "../../../api/meeting/meeting";
import { ParticipantUnitCard } from ".";
import { ParticipantUserCard } from ".";
import { PropTypes } from "prop-types";
import { SelectableMultiplePeople } from "../../SelectableLists/SelectablePeople";
import { SelectableMultipleUnits } from "../../SelectableLists/SelectableUnits";
import { StyledModal, StyledPeopleModal } from "../../../styles/StyledModal";
import { StyledUnitMembersContainer, StyledUnitMembersList } from "../../../styles/StyledUnit/StyledContent";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useMeetingContext } from "../../../context/meetingContext";
import AddIcon from "../../../assets/img/icons/add.svg";
import convertStringToColor from "../../../helpers/util/convertStringToColor";
import Modal from "../../Modal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function MeetingParticipants({ refetch }) {
	const meeting = useMeetingContext();
	const { id, guestUnits, guestUsers } = useMeetingContext();
	const { axiosPrivate } = useAxiosPrivate();

	const [openDropdowns, setOpenDropdowns] = useState({});
	const [wasEdited, setWasEdited] = useState(false);
	const [modalDeleteUserIsOpen, setModalDeleteUserIsOpen] = useState(false);
	const [modalDeleteUnitIsOpen, setModalDeleteUnitIsOpen] = useState(false);
	const [addUserModalIsOpen, setAddUserModalIsOpen] = useState(false);
	const [addUnitModalIsOpen, setAddUnitModalIsOpen] = useState(false);
	const [deletedUserId, setDeletedUserId] = useState(null);
	const [deletedUnitId, setDeletedUnitId] = useState(null);

	const [choosenPeople, setChoosenPeople] = useState({});
	const [choosenUnits, setChoosenUnits] = useState({});

	useEffect(() => {
		let dropdowns;
		for (const member of guestUsers) {
			dropdowns = { ...dropdowns, [`p${member.id}`]: false };
		}
		for (const unit of guestUnits) {
			dropdowns = { ...dropdowns, [`u${unit.id}`]: false };
		}
		setOpenDropdowns(dropdowns);
		setWasEdited(false);
	}, [guestUnits, guestUsers, wasEdited]);

	const handleDelete = async (deletedId, type) => {
		const choosenPeopleArray = [];
		guestUsers.map((e) => choosenPeopleArray.push(parseInt(e.id)));

		const choosenUnitsArray = [];
		guestUnits.map((e) => choosenUnitsArray.push(parseInt(e.id)));

		let resGuestUserArray = choosenPeopleArray;
		let resGuestUnitArray = choosenUnitsArray;
		if (type === "user") {
			resGuestUserArray = choosenPeopleArray.filter((e) => e !== parseInt(deletedId));
		} else {
			resGuestUnitArray = choosenUnitsArray.filter((e) => e !== parseInt(deletedId));
		}

		await editMeeting(
			axiosPrivate,
			id,
			{
				...meeting,
				unit: undefined,
				organizationUnit: 1,
				id: undefined,
				creator: undefined,
				hasMinutes: undefined,
				hasAgenda: undefined,
				guestUnits: resGuestUnitArray,
				guestUsers: resGuestUserArray,
			},
			() => {
				toast.success("Participant deleted");
				setWasEdited(true);
				refetch();
			}
		);
	};

	const handlePost = async (type) => {
		const choosenPeopleArray = [];
		const choosenUnitsArray = [];

		if (type === "user") {
			Object.keys(choosenPeople).map((e) => {
				if (choosenPeople[e]) choosenPeopleArray.push(parseInt(e));
			});
			setAddUserModalIsOpen(false);
		} else {
			Object.keys(choosenUnits).map((e) => {
				if (choosenUnits[e]) choosenUnitsArray.push(parseInt(e));
			});
			setAddUnitModalIsOpen(false);
		}

		guestUsers.map((e) => choosenPeopleArray.push(parseInt(e.id)));
		guestUnits.map((e) => choosenUnitsArray.push(parseInt(e.id)));

		await editMeeting(axiosPrivate, id, {
			...meeting,
			creator: undefined,
			unit: undefined,
			organizationUnit: 1,
			id: undefined,
			hasMinutes: undefined,
			hasAgenda: undefined,
			guestUnits: [...choosenUnitsArray],
			guestUsers: [...choosenPeopleArray],
		});
		await refetch();
	};

	return (
		<>
			<StyledUnitMembersContainer>
				<h2>Participants</h2>
				<StyledUnitMembersList>
					{guestUsers.length > 0 && !wasEdited ? (
						guestUsers.map((e, i) => (
							<ParticipantUserCard
								key={i}
								data={e}
								color={convertStringToColor(e.firstName + e.lastName)}
								openDropdowns={openDropdowns}
								setOpenDropdowns={setOpenDropdowns}
								direction={"left"}
								moreActionsPosition={"absolute"}
								openModal={(id) => {
									setDeletedUserId(id);
									setModalDeleteUserIsOpen(true);
								}}
								showOptions={true}
							/>
						))
					) : (
						<h6>No participants found</h6>
					)}
				</StyledUnitMembersList>
				<h2>Participants units</h2>
				<StyledUnitMembersList>
					{guestUnits.length > 0 && !wasEdited ? (
						guestUnits.map((e, i) => (
							<ParticipantUnitCard
								key={i}
								data={e}
								color={convertStringToColor(e.name)}
								openDropdowns={openDropdowns}
								setOpenDropdowns={setOpenDropdowns}
								direction={"left"}
								moreActionsPosition={"absolute"}
								openModal={(id) => {
									setDeletedUnitId(id);
									setModalDeleteUnitIsOpen(true);
								}}
								showOptions={true}
							/>
						))
					) : (
						<h6>No participants found</h6>
					)}
				</StyledUnitMembersList>
				<Button
					icon={AddIcon}
					onClick={() => {
						setAddUserModalIsOpen(true);
					}}
				>
					Add participant
				</Button>
				<Button
					icon={AddIcon}
					onClick={() => {
						setAddUnitModalIsOpen(true);
					}}
				>
					Add unit participant
				</Button>
			</StyledUnitMembersContainer>
			<Modal
				isOpen={modalDeleteUserIsOpen}
				onRequestClose={() => setModalDeleteUserIsOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal
					handleDelete={(id) => handleDelete(id, "user")}
					deletedId={deletedUserId}
					closeModal={() => setModalDeleteUserIsOpen(false)}
				/>
			</Modal>
			<Modal
				isOpen={modalDeleteUnitIsOpen}
				onRequestClose={() => setModalDeleteUnitIsOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal
					handleDelete={(id) => handleDelete(id, "unit")}
					deletedId={deletedUnitId}
					closeModal={() => setModalDeleteUnitIsOpen(false)}
				/>
			</Modal>
			<Modal
				isOpen={addUserModalIsOpen}
				onRequestClose={() => setAddUserModalIsOpen(false)}
				style={StyledPeopleModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setAddUserModalIsOpen(false);
					}}
				>
					Add Participants
				</ModalHeader>
				<SelectableMultiplePeople fetchPeople={getPeople} choosenPeople={choosenPeople} setChoosenPeople={setChoosenPeople} id={id}>
					<div className="action-buttons">
						<Button
							onClick={() => {
								setAddUserModalIsOpen(false);
							}}
							bg={false}
							small={true}
						>
							cancel
						</Button>
						<Button
							icon={AddIcon}
							onClick={() => {
								handlePost("user");
							}}
						>
							ADD PARTICIPANT
						</Button>
					</div>
				</SelectableMultiplePeople>
			</Modal>
			<Modal
				isOpen={addUnitModalIsOpen}
				onRequestClose={() => setAddUnitModalIsOpen(false)}
				style={StyledPeopleModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setAddUnitModalIsOpen(false);
					}}
				>
					Add Unit Participants
				</ModalHeader>
				<SelectableMultipleUnits
					fetchUnits={getUnits}
					choosenUnits={choosenUnits}
					setChoosenUnits={setChoosenUnits}
					name={"meetingUnits"}
					id={id}
				>
					<div className="action-buttons">
						<Button
							onClick={() => {
								setAddUnitModalIsOpen(false);
							}}
							bg={false}
							small={true}
						>
							cancel
						</Button>
						<Button
							icon={AddIcon}
							onClick={() => {
								handlePost("unit");
							}}
						>
							ADD UNIT PARTICIPANT
						</Button>
					</div>
				</SelectableMultipleUnits>
			</Modal>
		</>
	);
}

MeetingParticipants.propTypes = {
	refetch: PropTypes.func,
};
